import { useMutation } from '@tanstack/react-query';

import { organizationServices } from '@hero/services';

export const useAcceptInvite = options => {
  return useMutation(({ body }) => organizationServices.acceptInvite({ body }), {
    ...options
  });
};
